import { render, staticRenderFns } from "./dangdijingjifazhan.vue?vue&type=template&id=0391092e&scoped=true&"
import script from "./dangdijingjifazhan.vue?vue&type=script&lang=js&"
export * from "./dangdijingjifazhan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0391092e",
  null
  
)

export default component.exports